<template>
  <div>
    <!-- {{ items }} -->
    <div v-if="itemLocations[0]">
      {{ itemLocations }}
      <hr>
      <!-- {{ itemLocations[0].position }} -->
      {{ showMarkers }}
    </div>

    <div v-if="items" id='map' style="height: 400px; width: 100%;"></div>
  </div>
</template>

<script>
import gmapsInit from '../../utils/gmaps';
import MarkerClusterer from '@google/markerclusterer';

export default {
  props: ['items'],
  data() {
    return {
      itemLocations: [],
      google: null,
      geoencoder: null,
      map: null,
    }
  },

// https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
  async mounted() {

    try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
      this.google = await gmapsInit();
      this.geocoder = new this.google.maps.Geocoder();
      // const map = new google.maps.Map(document.getElementById('map'), {
      //   // zoom: 12,
      //   zoom: 3,
      //   // center: {lat: 52.520, lng: 13.410}
      //   center: {lat: 15.0, lng: 0.0}
      // });
      this.map = new this.google.maps.Map(document.getElementById('map'),
        {
          zoom: 2,
          center: {lat: 15.0, lng: 0.0}
        }
      );

      this.getLocations()

      this.geocoder.geocode({ address: 'Austria' }, (results, status) => {

      // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
        if (status !== 'OK' || !results[0]) {
          console.log('Error with geoencoder')
          throw new Error(status);
        }
        else {
          console.log('geoencoded fine')
        }

        // map.setCenter(results[0].geometry.location);
        // map.fitBounds(results[0].geometry.viewport);
      });

      // for (var item in this.items) {

      //   // https://developers.google.com/maps/documentation/geocoding/intro
      //   // https://developers.google.com/maps/faq#geocoder_queryformat
      //   // if (this.items[item].address1 && this.items[item].city && this.items[item].country) {
      //   if (this.items[item].city && this.items[item].country && item < 4) {
      //     console.log(this.items[item].city)
      //     console.log('Trying marker')
      //     // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
      //     geocoder.geocode({ address: this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
      //       if (status !== 'OK' || !results[0]) {
      //         console.log('Error with address geoencoder')
      //         throw new Error(status);
      //       }
      //       else {
      //         console.log('Got marker')
      //         console.log(results[0].geometry.location)
      //         // console.log(results[0].geometry.location.lat)
      //         this.itemLocations.push({position: results[0].geometry.location})
      //       }
      //     });
      //   } else {
      //     // console.log('No proper address')
      //   }
      // }

      // // this.itemLocations = [
      // //   {
      // //     position: new google.maps.LatLng(13.524834, 2.109823),
      // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/STAR-icon.png',
      // //   },
      // //   {
      // //     position: new google.maps.LatLng(49.884017, -97.168579),
      // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      // //   },
      // //   {
      // //     position: new google.maps.LatLng(45.421106, -75.690308),
      // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      // //   },
      // //   // {
      // //   //   position: new google.maps.LatLng(45.421106, -75.690308),
      // //   //   icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/redcross-icon.png',
      // //   // },
      // //   {
      // //     position: new google.maps.LatLng(41.5050175, -73.0682531),
      // //     // icon: 'https://thrivehire.s3.us-east-2.amazonaws.com/save-the-children-icon2.png',
      // //   }
      // // ]

      // console.log('Creating markers')
      // // https://developers.google.com/maps/documentation/javascript/custom-markers
      // var markers = this.itemLocations.map(function(itemLocation) {
      //   // return new google.maps.Marker({
      //   var marker = new google.maps.Marker({
      //     position: itemLocation.position,
      //     // position: new google.maps.LatLng(itemLocation.position),
      //     // position: new google.maps.LatLng(13.524834, 2.109823),
      //     // label: labels[i % labels.length]
      //     // icon: jobListing.icon,
      //     // title: 'test'
      //   });
      //   // marker.addListener('click', function() {
      //   //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //   //   markerClickHandler(marker);
      //   // });
      //   return marker;
      // });

      // new MarkerClusterer(map, markers, {
      //   imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // });

      var marker1 = new this.google.maps.Marker({
        // position: results[0].geometry.location,
        position: new this.google.maps.LatLng(49.884017, -97.168579),
        // label: labels[i % labels.length]
        // icon: jobListing.icon,
        // title: 'test'
        map: this.map
      });

    } catch (error) {
      console.log('Error with map')
      console.error(error);
    }

    // for (var item in this.items) {
    //   // console.log(this.items[item])
    //   // console.log(this.items[item].city)
    //   // console.log('hi')

    //   // console.log('ran')
    //   // console.log(this.user)
    //   // var mapExists = document.getElementById("map");
    //   // if (mapExists) {
    //   if (this.items[item].city && item < 5) {
    //     console.log(this.items[item].city)
    //     console.log(this.items[item].country)
    //     console.log(this.items[item].address1)
    //     try { // https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/

    //       // const google = await gmapsInit();
    //       // const geocoder = new google.maps.Geocoder();
    //       // // const map = new google.maps.Map(document.getElementById('map'), {
    //       // //   // zoom: 12,
    //       // //   zoom: 3,
    //       // //   // center: {lat: 52.520, lng: 13.410}
    //       // //   center: {lat: 15.0, lng: 0.0}
    //       // // });
    //       // const map = new google.maps.Map(document.getElementById('map'),
    //       //   {
    //       //     zoom: 3,
    //       //   }
    //       // );

    //       // geocoder.geocode({ address: 'Austria' }, (results, status) => {

    //       // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
    //       //   if (status !== 'OK' || !results[0]) {
    //       //     console.log('Error with geoencoder')
    //       //     throw new Error(status);
    //       //   }

    //       //   // map.setCenter(results[0].geometry.location);
    //       //   // map.fitBounds(results[0].geometry.viewport);
    //       // });

    //       // var marker = new google.maps.Marker({
    //       //       // position: results[0].geometry.location,
    //       //       position: new google.maps.LatLng(49.884017, -97.168579),
    //       //       // label: labels[i % labels.length]
    //       //       // icon: jobListing.icon,
    //       //       // title: 'test'
    //       //       map: map
    //       //     });

    //       // https://developers.google.com/maps/documentation/geocoding/intro
    //       // https://developers.google.com/maps/faq#geocoder_queryformat
    //       // if (this.items[item].address1 && this.items[item].city && this.items[item].country) {
    //       if (this.items[item].city && this.items[item].country) {
    //         console.log('Trying marker')
    //         // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
    //         geocoder.geocode({ address: this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
    //           if (status !== 'OK' || !results[0]) {
    //             console.log('Error with address geoencoder')
    //             throw new Error(status);
    //           }
    //           else {
    //             console.log('Got marker')
    //             console.log(results[0].geometry.location)
    //           }

    //           var marker = new google.maps.Marker({
    //             position: results[0].geometry.location,
    //             // position: new google.maps.LatLng(49.884017, -97.168579),
    //             // label: labels[i % labels.length]
    //             // icon: jobListing.icon,
    //             // title: 'test'
    //             map: map
    //           });
    //         });
    //       } else {
    //         console.log('No proper address')
    //       }

    //     } catch (error) {
    //       console.log('Error with map')
    //       console.error(error);
    //     }
    //   }

    //   // break;
    //   // if (item > 5) {
    //   //   break
    //   // }

    // }
  },
  methods: {
    getLocations() {
      // let google = await gmapsInit();
      // let geocoder = new google.maps.Geocoder();

      for (var item in this.items) {
        // console.log(this.items[item].city)

        // https://developers.google.com/maps/documentation/geocoding/intro
        // https://developers.google.com/maps/faq#geocoder_queryformat
        // if (this.items[item].address1 && this.items[item].city && this.items[item].country) {
        if (this.items[item].city && this.items[item].country && item < 4) {
          console.log('Trying marker')
          // geocoder.geocode({ address: this.items[item].address1 + ', ' + this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
          this.geocoder.geocode({ address: this.items[item].city + ', ' + this.items[item].country }, (results, status) => {
            if (status !== 'OK' || !results[0]) {
              console.log('Error with address geoencoder')
              throw new Error(status);
            }
            else {
              console.log('Got marker')
              console.log(results[0].geometry.location)
              this.itemLocations.push({position: results[0].geometry.location})
              if (this.itemLocations.length == 4) {
                // this.addMarkers()
              }

            }
          });
        } else {
          console.log('No proper address')
        }
      }
      // this.addMarkers()
    },
    addMarkers() {
      // if (this.itemLocations.length > 0) {

      var marker2 = new this.google.maps.Marker({
        // position: results[0].geometry.location,
        // position: new this.google.maps.LatLng(19.884017, -97.168579),
        position: this.itemLocations[0].position,
        // label: labels[i % labels.length]
        // icon: jobListing.icon,
        // title: 'test'
        map: this.map
      });
      var marker3 = new this.google.maps.Marker({
        // position: results[0].geometry.location,
        // position: new this.google.maps.LatLng(19.884017, -97.168579),
        position: this.itemLocations[2].position,
        // label: labels[i % labels.length]
        // icon: jobListing.icon,
        // title: 'test'
        map: this.map
      });

      console.log('Adding markers')
      console.log(this.itemLocations)
      console.log(this.itemLocations[0])
      console.log(this.itemLocations[0].position)

      // console.log('Creating markers')
      // // https://developers.google.com/maps/documentation/javascript/custom-markers
      // var markers = this.itemLocations.map(function(itemLocation) {
      //   // return new google.maps.Marker({
      //   var marker = new this.google.maps.Marker({
      //     // position: itemLocation.position,
      //     // position: new google.maps.LatLng(itemLocation.position),
      //     position: new this.google.maps.LatLng(13.524834, 2.109823),
      //     // label: labels[i % labels.length]
      //     // icon: jobListing.icon,
      //     // title: 'test'
      //   });
      //   // marker.addListener('click', function() {
      //   //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //   //   markerClickHandler(marker);
      //   // });
      //   return marker;
      // });

      // new MarkerClusterer(this.map, markers, {
      //   imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      // });

      // }
    },
  },
  computed: {
    showMarkers() {

      // if (this.itemLocations) {
      //   // https://developers.google.com/maps/documentation/javascript/custom-markers
      //   var markers = this.itemLocations.map(function(itemLocation) {
      //     // return new google.maps.Marker({
      //     var marker = new this.google.maps.Marker({
      //       // position: itemLocation.position,
      //       // position: new google.maps.LatLng(itemLocation.position),
      //       position: new this.google.maps.LatLng(13.524834, 2.109823),
      //       // label: labels[i % labels.length]
      //       // icon: jobListing.icon,
      //       // title: 'test'
      //     });
      //     // marker.addListener('click', function() {
      //     //   // infowindow.open(map, marker); // https://developers.google.com/maps/documentation/javascript/infowindows
      //     //   markerClickHandler(marker);
      //     // });
      //     return marker;
      //   });

      //   new MarkerClusterer(this.map, markers, {
      //     imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
      //   });
      // }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/global/MapBoard.vue